import React from "react";
import primaryPalette from "../../../images/v2/brand-asset/primaryPalette.png";

const PrimaryPalette = () => {
  const primaryPaletteItem = [
    "Our primary palette consists of Magenta, Black, and White — inspired by the power and brilliance of African women. At least one of these colours should appear in any She Code Africa branded application.",
    "These colours should only occasionally appear without Magenta.",
  ];
  return (
    <section
      id="primary-palette"
      className="w-full flex flex-col xl:relative xl:min-h-[580px] justify-between gap-6  bg-white"
    >
      <figure className="w-full h-[250px] xl:h-[550px] overflow-hidden">
        <img
          src={primaryPalette}
          className="w-full h-full object-contain"
          alt="Avatar Mark"
        />
      </figure>
      <ul className="w-[90%] max-w-[730px] xl:absolute xl:bottom-6 xl:left-1/2 xl:-translate-x-1/2 mx-auto mb-5 xl:mb-0 sm:flex-row flex-col flex gap-5 justify-between">
        {primaryPaletteItem.map((item, index) => (
          <li className="text-[#AB8599] xl:w-1/2 text-sm" key={index}>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default PrimaryPalette;
